export enum HostMerchantMessageType {
  WidgetGetHostOriginRequest = 'ADDI_WIDGET_GET_HOST_ORIGIN_REQUEST',
  WidgetGetHostOriginResponse = 'ADDI_WIDGET_GET_HOST_ORIGIN_RESPONSE',
  WidgetCloseModalRequest = 'ADDI_WIDGET_CLOSE_MODAL_REQUEST',
}
